var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"lbzui-404"},[_c('lbz-empty-state',{attrs:{"title":"Oops!","subtitle":"We can't seem to find the page you're looking for."},scopedSlots:_vm._u([{key:"start",fn:function(){return [_c('img',{attrs:{"src":require("../assets/img/placeholder@1x1.png")}})]},proxy:true},{key:"end",fn:function(){return [_c('lbz-button',{attrs:{"router-link":"","router-link-props":{
          to: '/',
          replace: true,
          exact: true
        },"tag":"a","type":"contained"}},[_vm._v("Back Home")])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }